export { supportsPassiveEvents } from 'detect-it';
//# sourceMappingURL=detect-passive-events.esm.js.map
